@if (logo && logo.links && logo.links[lang]) {
<a
  [attr.href]="logo.links[lang]"
  [ngClass]="['px-2', 'h-full', 'items-center', classes]"
  [style.backgroundColor]="logo.backgroundColor"
  target="_blank"
>
  <!-- eslint-disable-next-line -->
  <img [src]="logo.url" class="max-h-48" id="all_toolbar_img_logo" />
</a>
} @if (logo && (!logo.links || !logo.links[lang])) {
<div [style.backgroundColor]="logo.backgroundColor" class="h-full px-2 flex items-center">
  <!-- eslint-disable-next-line -->
  <img [attr.id]="htmlId || null" [src]="logo.url" class="max-h-48" />
</div>
}
